import { omit } from 'lodash';
import { RawCollection } from '../types';

interface MarkItemForRemovalProps {
    itemId: string;

    /**
     * collectionId is optional, but it's a slight optimization if we know it.
     */
    collectionId?: string;

    /**
     * True by default, set to false to unmark the item for removal.
     * @ignore
     */
    pendingRemoval?: boolean;
}

export const markItemForRemoval = (
    oldData: RawCollection[],
    { itemId, collectionId, pendingRemoval = true }: MarkItemForRemovalProps
): {
    newData?: RawCollection[];
    removedItem?: RawCollection['items'][number];
    removedItemIndex?: number;
    removedFromCollectionId?: string;
} => {
    let removedItem;
    let removedItemIndex;
    let removedFromCollectionId;

    const newData = oldData.map((collection) => {
        if (collectionId && collection.id !== collectionId) {
            return collection;
        }

        return {
            ...collection,
            items: collection.items.map((item, i) => {
                if (item.id === itemId) {
                    removedItem = item;
                    removedItemIndex = i;
                    removedFromCollectionId = collection.id;

                    return pendingRemoval
                        ? {
                              ...item,
                              pendingRemoval,
                          }
                        : omit(item, 'pendingRemoval');
                }

                return item;
            }),
        };
    });

    return { newData, removedItem, removedItemIndex, removedFromCollectionId };
};
